import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function Header() {
  return <header className="w-full bg-gradient-to-br from-yellow-400 via-yellow-300 to-yellow-400 shadow-md" data-id="element-38">
      <div className="py-3 px-4" data-id="element-39">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-2" data-id="element-40">
          <div className="flex items-center gap-2 md:gap-4" data-id="element-41">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/u53GDs2EPCe9qQT6kzQQ7V/MHDlogo-icon.png" alt="Mobile Home Doctor Logo" className="w-12 h-12 md:w-16 md:h-16" data-id="element-42" />
            <div data-id="element-43">
              <h1 className="text-lg md:text-3xl font-bold text-black italic leading-tight" data-id="element-44">
                Mobile Home Doctor, LLC
              </h1>
              <p className="text-xs md:text-sm text-gray-800" data-id="element-45">
                Mobile Home & Manufactured Home Repairs
              </p>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-3" data-id="element-46">
            <p className="text-base font-bold text-black" data-id="element-47">OPEN 7 DAYS</p>
            <span className="text-black" data-id="element-48">•</span>
            <p className="text-base font-bold text-black" data-id="element-49">FREE ESTIMATES</p>
            <span className="text-black" data-id="element-50">•</span>
            <p className="text-base font-bold text-black" data-id="element-51">SENIOR DISCOUNTS</p>
          </div>
          <a href="tel:407-655-9436" className="hidden md:inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 text-xl font-bold rounded-lg transition-colors" data-id="element-52">
            <PhoneIcon className="w-6 h-6" data-id="element-53" />
            407-655-9436
          </a>
        </div>
      </div>
    </header>;
}